import { datadogRum } from "@datadog/browser-rum";

export function trackStateClick(state: string) {
  datadogRum.addAction("opus_state_click", {
    state: state,
    timestamp: new Date().toISOString(),
  });
}

export function trackTopicClick(topic: string) {
  datadogRum.addAction("opus_topic_click", {
    topic: topic,
    timestamp: new Date().toISOString(),
  });
}
